export default __webpack_public_path__ + "static/media/excel.96424cce.svg";